import React from "react";
import Modal from "material-ui/Modal";
import Paper from "material-ui/Paper";
import Button from "material-ui/Button";
import Select from "material-ui/Select";
import Input, { InputLabel } from "material-ui/Input";
import Checkbox from "material-ui/Checkbox";
import Icon from "material-ui/Icon";
import Menu, { MenuItem } from "material-ui/Menu";
import {
  FormControl,
  FormControlLabel,
  FormHelperText
} from "material-ui/Form";
import TextField from "material-ui/TextField";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Tabs, { Tab } from "material-ui/Tabs";
import { withStyles } from "material-ui/styles";
import styles from "./styles";
import {
  validateFormData,
  validateTargetData
} from "../../../common/formtool";

import { ModalHeader, ModalContents, ModalFooter } from "../../common/modal";

class NewDeviceUpdateRepository extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      editSaving: false,
      errors: {},
      repository: {
        name: "",
        isdefault: false
      },
      error: null
    };
    this.onChange = this.onChange.bind(this);
    this.handleClose = this.handleClose.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
  }

  componentWillMount() {
    this.props.reset();
  }
 
  componentWillReceiveProps(nextProps) {
    const { editSaving } = this.state;
    const { repository } = nextProps;
    
    if (!editSaving) {
      if (repository) {
        this.setState({
          repository: { ...repository }
        });
        return;
      }
    }

    this.setState({
      repository: {
        ...this.state.repository
      }
    });
  }

  onChange(e) {
    let repository = { ...this.state.repository };
    
    if (e.target.name === 'isdefault') {
      repository.isdefault = !repository.isdefault;
    } else {
      repository[e.target.name] = e.target.value;
    }

    let errors = { ...this.state.errors };
    errors = {
      ...errors,
      [e.target.name]: false
    };
    if (e.target.name === "name") {
      delete errors["validName"];
    }
    this.setState({ repository: repository, errors });
  }

  handleClose() {
    this.props.close(false);
  }

  handleSubmit(e) {
    e.preventDefault();
    this.submit();
  }

  submit() {
    let {
      translate,
      mode,
      pager,
      create,
      update
    } = this.props;

    let repository = { ...this.state.repository };
    
    let validationObj = {
      name: {
        required: translate("formfield_error_general_required")
      }
    };

    let errors = validateFormData(
      { ...this.state.repository, validName: this.state.repository.name },
      validationObj
    );

    const missingFieldName = Object.keys(errors)[0];
    
    if (missingFieldName) {
      const textField = document.getElementsByName(missingFieldName)[0];
      textField && textField.focus();
    }

    if (Object.keys(errors).length) {
      this.setState({ errors: errors });
    } else {
      let self = this;
      let name = this.state.repository.name;
      
      if (mode === "edit") {
        this.setState(
          {
            editSaving: true
          },
          () => {
            update(this.state.repository, pager)
              .then(resp => {
                self.handleClose();
                self.props.removedSelectedRadioCheck();
              })
              .catch(err => {
                if (err.errors === "error_repositoryexists") {
                  self.setState({
                    error: {
                      type: "error_duplicate_repository",
                      data: name
                    }
                  });
                }
              });
          }
        );
      } else {
        create(repository, pager)
          .then(resp => {
            self.handleClose();
          })
          .catch(err => {
            if (err.errors === "error_repositoryexists") {
              self.setState({
                error: {
                  type: "error_duplicate_repository",
                  data: name
                }
              });
            }
          });
      }
    }
  }

  getTitle() {
      if (this.props.mode === "edit") {
        return this.props.translate("edit_repository");
      } else {
        return this.props.translate("add_repository");
      }
  }
  
  getModalError(error) {
    const { translate, classes } = this.props;
    if (error.type === "error_duplicate_repository") {
      return (
        <div className={classes.error}>
          <Typography type="subheading" color="inherit">
            {translate("error_duplicate_repository")}
          </Typography>
        </div>
      );
    }
  }
  
  render() {
    const {
      classes,
      languages,
      container,
      modal,
      mode,
      translate,
    } = this.props;

    const {
      repository,
      errors,
      error
    } = this.state;

    if (repository && (repository.isdefault === 'False' || repository.isdefault === 'false' || !repository.isdefault)) {
      repository.isdefault = false;
    } else {
      repository.isdefault = true;
    }

    return (
      <Modal open={modal} onClose={this.handleClose}>
        <div className={classes.root}>
        <form noValidate autoComplete="off" className={classes.form}>
          <Paper className={classes.modal}>
            <ModalHeader>
              <Grid
                container
                alignItems="center"
                direction="row"
                justify="flex-start"
              >
                <Grid item>
                  <Typography
                    type="headline"
                    color="inherit"
                    className={classes.modalHeader}
                  >
                    {this.getTitle()}
                  </Typography>
                </Grid>
              </Grid>
              <Button className={classes.close} onClick={this.handleClose}>
                <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents>
              {error && this.getModalError(error)}
                {(
                  <div>
                    <TextField
                      error={errors.name || errors.validName}
                      required
                      name="name"
                      label={translate("repository_name")}
                      margin="normal"
                      fullWidth
                      value={repository.name}
                      onChange={this.onChange}
                      helperText={translate("repository_name_help")}
                      inputProps={{
                        maxLength: 50
                      }}
                      autoFocus
                    />
                    <FormControlLabel
                    control={
                      <Checkbox
                        checked={repository.isdefault}
                        onChange={e => this.onChange(e)}
                        name="isdefault"
                        color="primary"
                      />
                    }
                    label={translate("isdefault")}
                  />
                  </div>
                )}
             
            </ModalContents>

            <ModalFooter>
              {(
                <Button
                  raised
                  color="primary"
                  className={classes.submit}
                  onClick={this.handleSubmit}
                  type="submit"
                >
                  {translate("general_submit")}
                </Button>
              )}
            </ModalFooter>
          </Paper>
          </form>
        </div>
      </Modal>
    );
  }
}

export default withStyles(styles)(NewDeviceUpdateRepository);
